import { UrlConstants } from "../url.constants";
export class ApiPropertyValuationprojectCycleSurveysConstants {
    static URL = UrlConstants.API_V2 + "PropertyValuationprojectCycleSurveys";
    static FUNCTION_DELETE_MULTIPLE_GENERAL_VALUATION_RUN_SURVEYS = "DeleteMultipleprojectCycleSurveys";
}
